import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { PricelistCaseFileDTO } from '@erp/rpc';
import { orpc } from '@/api/rpc/client';
import { resolveSelectedCaseFile } from './pricelistCaseSelectedFile';

export function useSelectedPricelistCaseFile(
  files: readonly PricelistCaseFileDTO[],
) {
  const [selectedDocumentId, setSelectedDocumentId] = useState<string | null>(
    null,
  );
  const selectedFile = resolveSelectedCaseFile(files, selectedDocumentId);
  const selectedPricelistQuery = useQuery({
    ...orpc.inventoryManagement.pricelist.get.queryOptions({
      input: { pdfDocumentId: selectedFile?.documentId ?? '' },
    }),
    enabled: selectedFile !== undefined,
  });

  return {
    selectedFile,
    setSelectedDocumentId,
    selectedPricelist: selectedPricelistQuery.data,
    isPricelistPending:
      selectedFile !== undefined && selectedPricelistQuery.isPending,
  };
}
